<!-- <form [formGroup]="form">

          <mat-form-field class="full-width-field">
              <input matInput placeholder="Search {{labelName}}" formControlName="name" id="id_number">

           </mat-form-field>

        </form> -->

<mat-card-title>Search for {{ name }}</mat-card-title>
<mat-card-content>
  <mat-form-field class="full-width-field">
    <input
      matInput
      placeholder="Search {{ name }}"
      [value]="query"
      (keyup)="search.emit($event.target.value)"
      id="id_number"
    />
  </mat-form-field>
  <mat-spinner
    [class.show]="searching"
    [diameter]="30"
    [strokeWidth]="3"
  ></mat-spinner>
</mat-card-content>
<mat-card-footer
  ><span *ngIf="error">{{ error }}</span></mat-card-footer
>

<form [formGroup]="searchForm" *ngIf="searchByDate">
  <div class="row justify-content-center">
    <div class="col-md-5">
      <mat-form-field class="full-width-field">
        <input
          matInput
          [matDatepicker]="picker"
          formControlName="startDate"
          placeholder="Start Date"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-hint></mat-hint>
      </mat-form-field>
    </div>

    <div class="col-md-5">
      <mat-form-field class="full-width-field">
        <input
          matInput
          [matDatepicker]="picker1"
          formControlName="endDate"
          placeholder="End Date"
          (dateChange)="onSearch(searchForm.value)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker1"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
        <mat-hint></mat-hint>
      </mat-form-field>
    </div>
  </div>
  <!-- <button (click)="onSearch(searchForm.value)"> submit</button> -->
</form>
